import React, { Component } from "react";
import axios from "axios";
import { serverLink } from "../../../../resources/url";
import swal from "sweetalert";
import CategoryForm from "./categoryform";
import Header from "../../../Header/header";
import { accessControl } from "../../../../permission/permission";

class CategoryManagement extends Component {
  constructor() {
    super();
    accessControl([1, 4]);
    this.state = {
      isLoading: false,
      categories: [],
      editingCategory: "",
      imagefile: "",
      formData: {
        categoryName: "",
      },
    };
  }

  componentDidMount() {
    this.fetchCategories();
  }

  async fetchCategories() {
    this.setState({ isLoading: true });
    try {
      const response = await axios.get(`${serverLink}gallery/category/list`);
      this.setState({
        categories: response.data,
        isLoading: false,
      });
    } catch (error) {
      console.error("Error fetching categories:", error);
      this.setState({ isLoading: false });
    }
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ isLoading: true });

    const { editingCategory, formData } = this.state;

    if (!formData.categoryName) {
      this.showAlert("Error", "Please enter category name", "error");
      this.setState({ isLoading: false });
      return;
    }

    try {
      const endpoint = editingCategory ? `${serverLink}gallery/category/update` : `${serverLink}gallery/category/add`;

      const method = editingCategory ? "patch" : "post";

      const { data } = await axios[method](endpoint, formData);

      if (data.message === "success") {
        this.showAlert("Success", `Category ${editingCategory ? "updated" : "added"} successfully`, "success");
        this.resetForm();
        this.fetchCategories();
      } else {
        this.showAlert("Error", data.message || "Operation failed", "error");
      }
    } catch (error) {
      console.error("Error:", error);
      this.showAlert("Error", "An error occurred", "error");
    } finally {
      this.setState({ isLoading: false });
    }
  };

  handleEdit = (category) => {
    this.setState({
      editingCategory: category,
      formData: {
        categoryName: category.categoryName,
        EntryID: category.EntryID,
      },
    });
  };

  handleDelete = async (categoryId) => {
    const confirm = await swal({
      title: "Are you sure?",
      text: "This will permanently delete the category!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (!confirm) return;

    try {
      this.setState({ isLoading: true });
      const { data } = await axios.delete(`${serverLink}gallery/category/delete/${categoryId}`);

      if (data.message === "deleted") {
        this.showAlert("Deleted!", "Category has been deleted.", "success");
        this.fetchCategories();
      } else {
        this.showAlert("Error", "Failed to delete category", "error");
      }
    } catch (error) {
      console.error("Delete error:", error);
      this.showAlert("Error", "Failed to delete category", "error");
    } finally {
      this.setState({ isLoading: false });
    }
  };

  resetForm = () => {
    this.setState({
      editingCategory: null,
      formData: { categoryName: "" },
    });
  };

  onEdit = (e) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [e.target.name]: e.target.value,
      },
    });
  };

  showAlert(title, msg, type) {
    return swal({
      title,
      text: msg,
      icon: type,
      button: "OK",
    });
  }

  render() {
    const { categories, isLoading, formData, editingCategory } = this.state;

    return (
      <>
        <Header isFaculty={false} />
        <div className="content d-flex flex-column flex-column-fluid" id="kt_content">
          {/* ... (keep your existing toolbar code) ... */}

          <div className="post d-flex flex-column-fluid" id="kt_post">
            <div id="kt_content_container" className="container-fluid">
              <div className="card mb-5 mb-xl-10">
                <div className="card-header">
                  <div className="card-title">
                    <h3>MANAGE CATEGORIES</h3>
                  </div>
                </div>

                {/* Category Form */}
                <CategoryForm
                  handleSubmit={this.handleSubmit}
                  onEdit={this.onEdit}
                  isLoading={isLoading}
                  data={formData}
                  isEditing={editingCategory}
                  onCancel={this.resetForm}
                />

                {/* Categories List */}
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table text-left table-striped">
                      <thead>
                        <tr>
                          <th>SN</th>
                          <th>Category Name</th>
                          <th>Edit</th>
                          <th>Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading && !categories.length ? (
                          <tr>
                            <td colSpan="2" className="text-center">
                              Loading...
                            </td>
                          </tr>
                        ) : categories.length === 0 ? (
                          <tr>
                            <td colSpan="2" className="text-center">
                              No categories found
                            </td>
                          </tr>
                        ) : (
                          categories.map((category,i) => (
                            <tr key={`category_${category.EntryID}`}>
                              <td className="text-left">{i+1}</td>
                              <td className="text-left">{category.CategoryName}</td>
                              <td>
                                <button className="btn btn-sm btn-primary me-2" onClick={() => this.handleEdit(category)}>
                                  Edit
                                </button>
                              </td>
                              <td>
                                <button className="btn btn-sm btn-danger" onClick={() => this.handleDelete(category.EntryID)}>
                                  Delete
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default CategoryManagement;
